import { initAxios } from '../api/init';
import { initStore } from '../store';

export function init() {
  initAxios();
  initStore();
}
